import history from 'shared/util/routing/history'

export function goToContact(id: string) {
  return history.push(`/people/contact/${encodeURIComponent(id)}`)
}
